<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/cyrus/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container flex items-stretch flex-col justify-center ">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">
                    {{$t('Login')}}
                  </h4>
                </div>
                <div>
                  <form @submit="loginJWT">
                    <vs-input
                      v-validate="'required|email|min:3'"
                      data-vv-validate-on="blur"
                      name="email"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      :label-placeholder="$t('Email')"
                      v-model="email"
                      @keypress.enter="loginJWT"
                      class="w-full"/>
                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                    <vs-input
                      data-vv-validate-on="blur"
                      v-validate="'required|min:6|max:10'"
                      type="password"
                      name="password"
                      icon-no-border
                      icon="icon icon-lock"
                      icon-pack="feather"
                      @keyup.enter="loginJWT"
                      :label-placeholder="$t('Password')"
                      v-model="password"
                      class="w-full mt-8"/>
                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                    <div class="flex flex-wrap justify-between my-5">
                      <router-link to="/auth/forget-password">
                        {{$t('Forgot Password ?')}}
                      </router-link>
                    </div>
                    <div class="flex flex-wrap justify-between mb-3">
                      <vs-button :disabled="!validateForm" @click="loginJWT">
                        {{$t('Login')}}
                      </vs-button>
                    </div>
                    <div>
                      <router-link to="/auth/register">
                        {{$t("Join Cyrus Book Store")}}
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        email: '',
        password: '',
        checkbox_remember_me: false
      }
    },
    computed: {
      validateForm() {
        return !this.errors.any() && this.email != '' && this.password != '';
      },
    },
    methods: {
      checkLogin() {
        // If user is already logged in notify
        if (this.$store.state.auth.isUserLoggedIn()) {
          // Close animation if passed as payload
          // this.$vs.loading.close()
          this.$vs.notify({
            title: '',
            text: 'You are already logged in!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          });
          return false
        }
        return true
      },
      loginJWT() {
        if (!this.validateForm) return;
        // if (!this.checkLogin()) return;
        // Loading
        this.$vs.loading()
        const payload = {
          userDetails: {
            email: this.email,
            password: this.password
          }
        };
        this.$store.dispatch('auth/loginJWT', payload)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(({response}) => {
            let msg = this.$t('Error Login ');
            if (response && response.status == 422) {
              msg = response.data.message;
            }
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Error',
              text: msg,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
          })
      },
      registerUser() {
        if (!this.checkLogin()) return
        this.$router.push('/auth/register').catch(() => {
        })
      }
    }
  }

</script>

<style lang="scss">
  .login-tabs-container {
    min-height: 505px;

    .con-tab {
      padding-bottom: 14px;
    }

    .con-slot-tabs {
      margin-top: 1rem;
    }
  }
</style>

